import { render } from "./FrittiMenu.vue?vue&type=template&id=5cc6af0e"
import script from "./FrittiMenu.vue?vue&type=script&lang=js"
export * from "./FrittiMenu.vue?vue&type=script&lang=js"

import "./FrittiMenu.vue?vue&type=style&index=0&id=5cc6af0e&lang=css"

import exportComponent from "C:\\Users\\sciam\\Desktop\\Workspaces\\local\\workspace_vue\\alternativa-takeaway-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__